module.exports = __webpack_public_path__ + "img/Sonder2018.c4cd4a94.jpg";